<div class="ua-page">
  <header>
    <h1>{{ 'userActivity.title' | translate }}</h1>
    <p class="ua-subtitle">{{ 'userActivity.subtitle' | translate }}</p>
  </header>

  <p *ngIf="failed()" class="ua-error" role="alert">{{ 'userActivity.loadFailed' | translate }}</p>

  <!-- Every figure is a doorway when a screen explains it. -->
  <section class="ua-stats">
    <a class="ua-stat" routerLink="/users">
      <span class="ua-stat-value">{{ countUsers() }}</span>
      <span class="ua-stat-label">{{ 'userActivity.registered' | translate }}</span>
      <span class="ua-stat-hint is-flat">{{ 'userActivity.inactiveShare' | translate: { share: inactiveShare() } }}</span>
      <span class="ua-stat-hint" *ngIf="signupsGrowth() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'userActivity.signupsGrowth' | translate }}
      </span>
    </a>
    <article class="ua-stat is-live">
      <span class="ua-stat-value">{{ countEngaged() }}</span>
      <span class="ua-stat-label">{{ 'userActivity.engaged' | translate: { days: lastDays() } }}</span>
      <span class="ua-stat-hint">{{ engagedShare() }}% {{ 'userActivity.engagedShare' | translate }}</span>
      <span class="ua-stat-hint is-flat">{{ 'userActivity.averagePerActive' | translate: { count: averagePerActive() } }}</span>
      <span class="ua-stat-hint" *ngIf="activesGrowth() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'userActivity.activesGrowth' | translate }}
      </span>
    </article>
    <a class="ua-stat" routerLink="/events">
      <span class="ua-stat-value">{{ countFutureEvents() }}</span>
      <span class="ua-stat-label">{{ 'userActivity.upcoming' | translate }}</span>
      <span class="ua-stat-hint is-flat">{{ 'userActivity.shareOfAll' | translate: { share: upcomingShare() } }}</span>
      <span class="ua-stat-hint" *ngIf="creationsTrend() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'userActivity.creationsGrowth' | translate }}
      </span>
    </a>
    <a class="ua-stat" routerLink="/past-events">
      <span class="ua-stat-value">{{ countPastEvents() }}</span>
      <span class="ua-stat-label">{{ 'userActivity.past' | translate }}</span>
      <span class="ua-stat-hint is-flat">{{ 'userActivity.shareOfAll' | translate: { share: pastShare() } }}</span>
      <span class="ua-stat-hint" *ngIf="heldTrend() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'userActivity.heldGrowth' | translate }}
      </span>
    </a>
    <a class="ua-stat" routerLink="/groups">
      <span class="ua-stat-value">{{ countGroups() }}</span>
      <span class="ua-stat-label">{{ 'userActivity.groups' | translate }}</span>
      <span class="ua-stat-hint is-flat">{{ 'userActivity.perGroup' | translate: { count: activitiesPerGroup() } }}</span>
      <span class="ua-stat-hint" *ngIf="groupsTrend() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'userActivity.groupsGrowth' | translate }}
      </span>
    </a>
  </section>

  <section class="ua-block">
    <div class="ua-block-head">
      <div>
        <h2>{{ 'userActivity.engagedTitle' | translate }}</h2>
        <p class="ua-note">{{ 'userActivity.engagedNote' | translate }}</p>
      </div>
      <div class="ua-periods" role="group" [attr.aria-label]="'userActivity.period' | translate">
        <button
          type="button"
          *ngFor="let period of periods"
          [class.is-on]="lastDays() === period"
          (click)="setPeriod(period)"
        >
          {{ 'userActivity.periodDays' | translate: { days: period } }}
        </button>
      </div>
    </div>

    <div class="ua-table-wrapper" *ngIf="engagedUsers().length > 0">
      <table class="ua-table">
        <thead>
          <tr>
            <th scope="col" class="is-numeric">#</th>
            <th scope="col">{{ 'userActivity.member' | translate }}</th>
            <th scope="col" class="is-bar">{{ 'userActivity.activityCount' | translate }}</th>
            <th scope="col" class="is-numeric"></th>
            <th scope="col">{{ 'userActivity.lastActivity' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of engagedUsers(); let rank = index" [routerLink]="['/users', user.id]" class="is-clickable">
            <td class="is-numeric is-muted">{{ rank + 1 }}</td>
            <th scope="row">{{ user.firstName }} {{ user.lastName }}</th>
            <td class="is-bar">
              <span class="ua-bar-track" aria-hidden="true">
                <span class="ua-bar-value" [style.width]="barWidth(user.totalEvents)"></span>
              </span>
            </td>
            <td class="is-numeric">{{ user.totalEvents }}</td>
            <td class="is-muted">{{ user.lastEventDate | date: 'dd/MM/yyyy' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="ua-empty" *ngIf="engagedUsers().length === 0">{{ 'userActivity.empty' | translate }}</p>
  </section>
</div>
